export enum ListingType {
  brand = "brand",
  category = "category",
  promotion = "promotion",
  mostSold = "most-sold",
  generic = "generic"
}
